// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_1Hv-f","label":"index_label_1q2p0"};